import { render, staticRenderFns } from "./SupplierEdit.vue?vue&type=template&id=680f192c&"
import script from "./SupplierEdit.vue?vue&type=script&lang=js&"
export * from "./SupplierEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports